import React, { useState, useRef, useEffect } from 'react';
import logo from './images/logo.png';

function Projects({ projects, trailers = [], movies = [] }) {
  const [showTrailer, setShowTrailer] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Function to play trailer
  const playTrailer = (trailer) => {
    if (trailer && trailer.videoUrl) {
      setShowTrailer(trailer.videoUrl);
    }
  };

  // Function to close trailer
  const closeTrailer = () => {
    setShowTrailer(null);
  };

  // Categories for the dropdown
  const categories = ['All', 'Movie', 'Web Series', 'Micro Dramas','Reality Shows'];

  // Filter projects based on selected category
  const filteredProjects = selectedCategory === 'All'
    ? projects
    : projects.filter(project => project.category === selectedCategory);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Handle category selection
  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setIsDropdownOpen(false);
  };

  return (
    <>
      {/* Main Content - "Projects" */}
      <main className="projects-main">
        <section className="projects-hero">
          <div className="projects-header-container">
            <h1 className="projects-heading">PROJECTS</h1>
            <div className="category-filter" ref={dropdownRef}>
              <button
                className="category-dropdown"
                onClick={toggleDropdown}
              >
                {selectedCategory === 'All' ? 'Select Category' : selectedCategory}
                <span className="dropdown-arrow">{isDropdownOpen ? '▲' : '▼'}</span>
              </button>
              {isDropdownOpen && (
                <div className="category-dropdown-menu">
                  {categories.map(category => (
                    <div
                      key={category}
                      className="category-dropdown-item"
                      onClick={() => handleCategorySelect(category)}
                    >
                      {category === 'All' ? 'All' : category}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="projects-grid">
            {filteredProjects.map((project) => (
              <div className="project-poster" key={project.id}>
                <img src={project.imageUrl} alt={project.title} />
                <div className="project-overlay">
                  <div className="project-options">
                    <button
                      className="project-option-btn bts-btn"
                      onClick={() => window.location.href = `/bts-projects#video-${project.id}`}
                    >
                      BTS Projects
                    </button>
                    <button
                      className="project-option-btn trailer-btn"
                      onClick={() => {
                        const trailer = trailers && project.movie ? trailers.find(t => t.movie === project.movie) : null;
                        if (trailer) {
                          playTrailer(trailer);
                        } else {
                          alert("No trailer available for this project");
                        }
                      }}
                    >
                      Trailer
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>

      {/* Trailer Modal */}
      {showTrailer && (
        <div className="trailer-modal" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10000
        }}>
          <div className ='trailer-wrapper'   style={{
            position: 'relative',
            width: '90%',
            maxWidth: '1000px',
            maxHeight: '90vh'
          }}>
            <button
              onClick={closeTrailer}
              className='trailer-close'
              style={{
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'transparent',
                border: 'none',
                color: 'white',
                fontSize: '24px',
                cursor: 'pointer',
                zIndex: 10001
                
              }}
            >
              ×
            </button>
            <video
              src={showTrailer}
              controls
              autoPlay
              className='trailer-iframe'
              allowFullScreen
              allow='autoplay ; FullScreen ;'
              style={{
                width: '100%',
                height: '100%',
                maxHeight: '80vh',
                borderRadius: '10px'
              }}
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </>
  );
}

export default Projects;